export  default [
    {
        path: "/linkage",
        name: "linkage",
        component: () => import("./index"),
        meta: {
            permiss:['LINKAGE_SHOW'],
            title: "智能场景"
        },
    },
    {
        path: "/linkage/add",
        name: "addLinkage",
        component: () => import("./Update.vue"),
        meta: {
            permiss:['LINKAGE_ADD'],
            title: "新增场景"
        }
    },
    {
        path: "/linkage/update/:id",
        name: "updateLinkage",
        component: () => import("./Update.vue"),
        meta: {
            permiss:['LINKAGE_EDIT'],
            title: "编辑场景"
        }
    },
    {
        path: "/linkage/addRules",
        name: "addLinkage",
        component: () => import("./UpdateRules.vue"),
        meta: {
            permiss:['LINKAGE_ADD'],
            title: "新增场景"
        }
    },
    {
        path: "/linkage/updateRules/:id",
        name: "updateLinkage",
        component: () => import("./UpdateRules.vue"),
        meta: {
            permiss:['LINKAGE_EDIT'],
            title: "编辑场景"
        }
    },
]